import { HelpCenterRounded } from "@mui/icons-material";

export const helpCenter = (props) => {
  return <HelpCenterRounded {...props} />;
};
